import React from "react";
import { MapPin, MessageCircle, ArrowRight } from "lucide-react";
import { Reveal } from "../Reveal";
import { useForm } from "../../context/FormContext";
import { CONTACT } from "../../config";

export function FinalInvite() {
  const { requestAvailability } = useForm();
  const wa = `${CONTACT.whatsappBase}?text=${encodeURIComponent("Hi! I have a question about DMediaClub.")}`;
  const mapQ = encodeURIComponent(`${CONTACT.addressLine1}, ${CONTACT.addressLine2}`);
  return (
    <section className="bg-berry text-cream py-20 md:py-28">
      <div className="max-w-[1320px] mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <Reveal><span className="sticker" style={{ background: "#FBE08A" }}>Created to create</span></Reveal>
          <Reveal delay={0.05}>
            <h2 className="display text-4xl sm:text-5xl md:text-6xl mt-6">Bring Your Next Idea to Life at DMediaClub</h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-cream/80 max-w-lg">Tell us what you want to create and we’ll help you find a date. Every request is personally reviewed and we follow up within one business day.</p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <button onClick={() => requestAvailability()} className="btn inline-flex items-center justify-center gap-2 bg-butter text-charcoal border-2 border-charcoal px-7 py-4 shadow-[4px_4px_0_#2A1020]">
                Inquire About a Booking <ArrowRight size={18} strokeWidth={2} />
              </button>
              <a href={wa} target="_blank" rel="noreferrer" className="btn inline-flex items-center justify-center gap-2 bg-transparent text-cream border-2 border-cream/60 px-7 py-4 hover:bg-cream/10">
                <MessageCircle size={17} strokeWidth={2} /> Ask on WhatsApp
              </a>
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-8 flex items-start gap-2 text-cream/80">
              <MapPin size={18} strokeWidth={2} className="mt-0.5 shrink-0" />
              <p>{CONTACT.addressLine1}, {CONTACT.addressLine2} · Near International Drive · Free parking</p>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <div className="card-soft overflow-hidden bg-cream h-[320px] md:h-[420px]">
            <iframe title="DMediaClub location" width="100%" height="100%" style={{ border: 0, minHeight: 320 }} loading="lazy" referrerPolicy="no-referrer-when-downgrade" src={`https://www.google.com/maps?q=${mapQ}&output=embed`} />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
